import { render, staticRenderFns } from "./agendaSuratMasuk.vue?vue&type=template&id=56561d38"
import script from "./agendaSuratMasuk.vue?vue&type=script&lang=js"
export * from "./agendaSuratMasuk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QList,QItemLabel,QItem,QItemSection,QIcon,QMenu,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QList,QItemLabel,QItem,QItemSection,QIcon,QMenu,QDialog,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
